import { PublicClientApplication } from '@azure/msal-browser';

export const getMsalConfig = authority => ({
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority,
    redirectUri: window.location.origin,
    knownAuthorities: [process.env.REACT_APP_MSAL_AUTHORITY_URL],
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
});

export const createMsalInstance = authority =>
  new PublicClientApplication(getMsalConfig(authority));
